<script>
import { BProgressBar } from "bootstrap-vue";

export default {
  extends: BProgressBar
};
</script>